var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    _vm._l(_vm.groupedTags, function(tags, tagType) {
      return _c(
        "div",
        { key: tagType, staticClass: "timeline__item-container" },
        [
          _c(
            "div",
            { staticClass: "timeline__item timeline__item--hide-timeline" },
            [
              _c("i", { staticClass: "fa fa-tag m-t-2 f-s-10" }),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "m-l-7 m-b-3" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm._f("camelCaseFormat")(tagType)))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  _vm._l(tags, function(tag, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "generic-args" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "generic-args__name overflow-ellipsis"
                          },
                          [
                            _c(
                              "TruncatedTextCopy",
                              {
                                attrs: {
                                  title: tag.name,
                                  "copy-text": tag.name,
                                  placement: "top"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("camelCaseFormat")(tag.name)
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "generic-args__value" },
                          [
                            _c(
                              "TruncatedTextCopy",
                              {
                                attrs: {
                                  title: "Click to filter",
                                  "copy-text": tag.value,
                                  placement: "top"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    _vm.tagActionsAvailable
                                      ? {
                                          key: "extras",
                                          fn: function() {
                                            return [
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip.top",
                                                      value:
                                                        "Add Tag as Column",
                                                      expression:
                                                        "'Add Tag as Column'",
                                                      modifiers: { top: true }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "btn btn-link m-l-2 m-t-2 p-0 no_border truncated-text-copy__icon",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$emit(
                                                        "addTagAsColumn",
                                                        tag
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-columns"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip.top",
                                                      value: "Click to filter",
                                                      expression:
                                                        "'Click to filter'",
                                                      modifiers: { top: true }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "btn btn-link m-l-2 m-t-2 p-0 no_border truncated-text-copy__icon",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addTagFilter(
                                                        tag
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-filter"
                                                  })
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      : null
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "filterable-cell",
                                    on: {
                                      click: function($event) {
                                        return _vm.addTagFilter(tag)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(tag.value) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }